import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'dot-loader',
  templateUrl: './dot-loader.component.html',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .small-loader {
        width: 1rem !important;
        height: 1rem !important;
        margin-right: 0.5rem;
      }
    `,
  ],
})
export class DotLoader {
  visibility = input<boolean>(true);
  large = input<boolean>(false);
  small = input<boolean>(false);
  description = input<string>('');
  fast = input<boolean>(false);
}
